import { render, staticRenderFns } from "./AllocatedProlancers.vue?vue&type=template&id=68aa9f6d&scoped=true&"
import script from "./AllocatedProlancers.vue?vue&type=script&lang=js&"
export * from "./AllocatedProlancers.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProlancers.vue?vue&type=style&index=0&id=68aa9f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa9f6d",
  null
  
)

export default component.exports